/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Failed_To_Load_Translations_CountInputs */

const en_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to load ${i?.count} translation(s)`)
};

const fr_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du chargement de ${i?.count} traduction(s)`)
};

const de_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Übersetzung(en) konnten nicht geladen werden`)
};

const it_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile caricare ${i?.count} traduzione/i`)
};

const ru_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить ${i?.count} перевод(ов)`)
};

const es_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar ${i?.count} traducción(es)`)
};

const zh_cn2_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`加载 ${i?.count} 个翻译失败`)
};

const ja_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}件の翻訳を読み込めませんでした`)
};

const hi_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद लोड करने में विफल`)
};

const pt_pt2_failed_to_load_translations_count = /** @type {(inputs: Failed_To_Load_Translations_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao carregar ${i?.count} tradução(ões)`)
};

/**
* | output |
* | --- |
* | "Failed to load {count} translation(s)" |
*
* @param {Failed_To_Load_Translations_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_load_translations_count = /** @type {((inputs: Failed_To_Load_Translations_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Load_Translations_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_load_translations_count(inputs)
	if (locale === "de") return de_failed_to_load_translations_count(inputs)
	if (locale === "it") return it_failed_to_load_translations_count(inputs)
	if (locale === "ru") return ru_failed_to_load_translations_count(inputs)
	if (locale === "es") return es_failed_to_load_translations_count(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_load_translations_count(inputs)
	if (locale === "ja") return ja_failed_to_load_translations_count(inputs)
	if (locale === "hi") return hi_failed_to_load_translations_count(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_load_translations_count(inputs)
	return en_failed_to_load_translations_count(inputs)
});